import React from 'react';

const HeaderLogoutIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#FDE0E0" />
      <path
        d="M20.8 6H18.2C15 6 13 8 13 11.2V15.25H17.44L15.37 13.18C15.22 13.03 15.15 12.84 15.15 12.65C15.15 12.46 15.22 12.27 15.37 12.12C15.66 11.83 16.14 11.83 16.43 12.12L19.78 15.47C20.07 15.76 20.07 16.24 19.78 16.53L16.43 19.88C16.14 20.17 15.66 20.17 15.37 19.88C15.08 19.59 15.08 19.11 15.37 18.82L17.44 16.75H13V20.8C13 24 15 26 18.2 26H20.79C23.99 26 25.99 24 25.99 20.8V11.2C26 8 24 6 20.8 6Z"
        fill="#E01D1D"
      />
      <path
        d="M6.75 15.25C6.34 15.25 6 15.59 6 16C6 16.41 6.34 16.75 6.75 16.75H13V15.25H6.75Z"
        fill="#E01D1D"
      />
    </svg>
  );
};

export default HeaderLogoutIcon;
